import React from "react";

import "./dishItem.css";

export const DishItem = ({ dish, index }) => {
  return (
    <>
      <div className="orderbodyContainer__dishItemContainer">
        <div className="dishItemContainer__dishName">
          {index + 1}) {dish.name}{" "}
        </div>
        <div className="dishItemContainer__dishCounter"> x{dish.amount} </div>
        <div className="dishItemContainer__dishCost">
          {dish.price * dish.amount}&nbsp;$
        </div>
      </div>
    </>
  );
};

export default DishItem;
